module.exports = __webpack_public_path__ + "img/ru.e05493d0.svg";